import { CommonModule, DatePipe } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { OverlayPanel, OverlayPanelModule } from 'primeng/overlaypanel';

import { NotificationService } from '../../services/notification.service';
import { UserNotification } from '../../models/notification.model';

/**
 * Header-Glocke mit Unread-Badge + Mini-Dropdown der letzten 8 Benachrichtigungen.
 * Tieflink öffnet die volle <c>/benachrichtigungen</c>-Page; einzelne Items markieren
 * sich beim Klick als gelesen.
 */
@Component({
  selector: 'app-notifications-bell',
  standalone: true,
  imports: [CommonModule, RouterLink, OverlayPanelModule, DatePipe],
  templateUrl: './notifications-bell.component.html',
  styleUrl: './notifications-bell.component.scss',
})
export class NotificationsBellComponent {
  readonly notifications = inject(NotificationService);

  readonly open = signal(false);

  togglePanel(event: Event, panel: OverlayPanel): void {
    panel.toggle(event);
  }

  async onItemClick(item: UserNotification): Promise<void> {
    if (!item.read) {
      await this.notifications.markReadOptimistic(item.id);
    }
  }

  async markAll(): Promise<void> {
    // Optimistic: lokal alles auf gelesen setzen, dann POST.
    const updated = this.notifications.recent().map((n) => ({ ...n, read: true }));
    this.notifications.recent.set(updated);
    this.notifications.unreadCount.set(0);
    await this.notifications.markAllRead().toPromise();
    await this.notifications.refresh();
  }
}
